<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
            v-if="data.form"
        >

            <rkm-area
                no-margin-top
                title="Filtros"
                type="fieldset"
            >
                <template slot="trailing">
                    <rkm-button
                        :title="filtroVisible ? 'Ocultar' : 'Exibir'"
                        @click="filtroVisible = !filtroVisible"
                        color="primary"
                        small
                    >
                        <rkm-icon :icon="`angle-double-${filtroVisible ? 'up' : 'down'}`" />
                    </rkm-button>
                </template>

                <component
                    :is="'rkm-collapse'"
                    :visible="filtroVisible"
                >

                    <rkm-row>

                        <rkm-col cols="6">
                            <rkm-form-date-picker
                                range
                                :range-inline="false"
                                start-label="Período de"
                                end-label="Até"
                                v-model="model.periodo"
                                :max-date="data.form.dataAtual"
                                :start-validations="validations.periodo.start"
                                :end-validations="validations.periodo.end"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="agendamentoExame"
                                label="Exame / Grupo"
                                show-default-option
                                text-field="nome"
                                v-model="model.exameId"
                                default-option-text="Todos"
                                value-field="id"
                                @change="setListagem()"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="unidadeSolicitante"
                                label="Unidade solicitante"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.unidadeId"
                                value-field="unidadeId"
                                default-option-text="Todas"
                                @change="setListagem()"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="infraestruturas"
                                textField="nome"
                                v-model="model.infraestruturaId"
                                default-option-text="Todos"
                                valueField="id"
                                show-default-option
                                @change="setListagem()"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-select
                                :options="unidadeColeta"
                                label="Local de coleta"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.coletaUnidadeId"
                                value-field="unidadeId"
                                :validations="validations.coletaUnidade"
                                @change="setListagem()"
                                default-option-text="Todos"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <rkm-form-select
                                label="Local de atendimento"
                                :options="coletaInfraestruturas"
                                textField="nome"
                                v-model="model.coletaInfraestruturaId"
                                valueField="id"
                                show-default-option
                                :validations="validations.coletaInfraestrutura"
                                @change="setListagem()"
                                default-option-text="Todos"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="flex-nowrap">

                        <rkm-col cols="2">
                            <rkm-form-select
                                label="Status"
                                :options="status"
                                textField="descricao"
                                v-model="model.statusId"
                                valueField="statusId"
                                show-default-option
                                @change="setListagem()"
                                default-option-text="Todos"
                            />
                        </rkm-col>

                        <rkm-col cols="4" >
                            <rkm-form-input-autocomplete
                                :searchFields="localPaciente.autocompleteFieldsPaciente.paciente"
                                :repository="repositories.paciente"
                                v-model="paciente"
                                :text-field="(item) =>  item.cidadao.cns ? `${this.formatCns(item.cidadao.cns)} - ${item.cidadao.nome}` : item.cidadao.nome"
                                label="Paciente"
                                uppercase
                                @select="setListagem()"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Prontuário"
                                v-model="model.prontuario"
                                number
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Protocolo do agendamento"
                                v-model="model.agendamentoNumero"
                                number
                            />
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-button
                                :label="false"
                                color="primary"
                                @click="$refs.Form.validate(search)"
                            >
                                Buscar
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click="resetForm()"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </component>
            </rkm-area>
        </rkm-form>

        <rkm-row v-if="isSearch">

            <rkm-col
                cols="12"
            >
                <rkm-area
                    title="Status dos exames"
                    type="fieldset"
                >
                    <rkm-row>

                        <rkm-col
                            class="flex-grow-1"
                        >
                            <rkm-form-input
                                label="Agendado"
                                :disabled="true"
                                v-model="model.agendado"
                            />
                        </rkm-col>

                        <rkm-col
                            class="flex-grow-1"
                        >
                            <rkm-form-input
                                label="Realizado"
                                :disabled="true"
                                v-model="model.realizado"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Duplicidade"
                                :disabled="true"
                                v-model="model.duplicidade"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                label="Outros"
                                :disabled="true"
                                v-model="model.outros"
                            />
                        </rkm-col>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                            label="Faltou"
                            :disabled="true"
                            v-model="model.faltou"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="isSearch">
            <rkm-col cols="12">

                <rkm-area
                    title="Atribuir para todos"
                    type="fieldset"
                    no-margin-top
                >

                    <rkm-row>
                        <rkm-col cols="6">

                            <rkm-form-select
                                label="Profissional de coleta"
                                :options="usuario"
                                textField="usuarioOcupacao"
                                v-model="usuarioId"
                                valueField="id"
                                show-default-option
                                class="pt-0 mb-0"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-1">

                            <rkm-form-select
                                label="Status"
                                :options="data.form.status"
                                textField="descricao"
                                v-model="statusId"
                                valueField="id"
                                show-default-option
                                class="pt-0 mb-0"
                            />
                        </rkm-col>

                        <rkm-col cols="auto">

                            <rkm-button
                                color="primary"
                                class="mt-4"
                                @click="handleAtribuir()"
                                :disabled="!usuarioId && !statusId"
                            >
                                Atribuir
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-3" v-if="isSearch">
            <rkm-col>
                <rkm-button
                    @click="handleListPrint()"
                    color="primary"
                    class="mb-2"
                    :disabled="itemsNotSave && itemsNotSave.length == 0"
                >
                    Imprimir listagem
                </rkm-button>

                <template>
                    <rkm-button
                        @click="handleEtiquetaPrint()"
                        class="mb-2"
                        :disabled="itemsNotSave && itemsNotSave.length == 0"
                    >
                        Imprimir etiqueta(s)
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-row
            v-for="(agendamento, index) in itemsNotSave"
            :key="index"
        >

            <rkm-col
                class="mb-2"
                cols="12"
            >

                <rkm-list-group>
                    <rkm-list-group-item
                        class="rkm-list-group-item pr-0 pl-1"
                    >

                        <rkm-row>

                            <rkm-col class="flex-grow-1">
                                <h4 class="mb-0">{{ agendamento.pacienteNome }}</h4>
                                <h4 class="mb-0" v-if="agendamento.pacientePreferenciaNome">
                                    <strong>({{ agendamento.pacienteNomeSocial }})</strong>
                                </h4>
                            </rkm-col>

                            <rkm-col cols="auto">

                                <rkm-button
                                    @click="$refs.ModalPacienteCadastroSimplificado.open(agendamento.pacienteId)"
                                    color="primary"
                                    small
                                >
                                    Atualizar cadastro
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Idade:</strong> {{ agendamento.pacienteIdade }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Data de nascimento:</strong> {{ agendamento.pacienteNascimento }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Prontuário:</strong> {{ agendamento.pacienteProntuario }}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Raça/Cor:</strong> {{ agendamento.cidadaoRacaCor }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Médico solicitante:</strong> {{ agendamento.medicoNome }}
                            </rkm-col>

                            <rkm-col cols="6">
                                <strong>Unidade solicitante:</strong> {{ agendamento.unidadeNome }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Local de atendimento:</strong> {{ agendamento.infraestruturaNome }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Protocolo:</strong> {{ agendamento.agendamentoNumero }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Profissional agendador:</strong> {{ agendamento.agendadorNome }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="4" v-if="agendamento.regulacaoSolicitacaoId && agendamento.controlaProtocoloFechamento">

                                <rkm-area
                                    title="Protocolo de fechamento"
                                    no-margin-top
                                >
                                    <rkm-row>
                                        <rkm-col cols="12">

                                            <rkm-form-input
                                                label="Número do protocolo"
                                                name="Protocolo de fechamento"
                                                v-model="agendamento.protocoloFechamento"
                                                class="pt-0 mb-0"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>

                            <rkm-col :cols="agendamento.regulacaoSolicitacaoId && agendamento.controlaProtocoloFechamento ? '8' : '12'">

                                <rkm-area
                                    title="Profissional responsável"
                                    no-margin-top
                                >
                                    <rkm-row>
                                        <rkm-col cols="6">

                                            <rkm-form-select
                                                label="Profissional de coleta"
                                                :options="usuario"
                                                name="Usuário de coleta"
                                                textField="usuarioOcupacao"
                                                v-model="agendamento.usuarioId"
                                                valueField="id"
                                                show-default-option
                                                class="pt-0 mb-0"
                                                @change="handleOcupacao(agendamento)"
                                            />
                                        </rkm-col>

                                        <rkm-col cols="6" v-if="agendamento.usuarios.length !== 1">

                                            <rkm-form-select
                                                label="Profissional do laboratório"
                                                :options="agendamento.usuarios"
                                                name="Usuário do laboratório"
                                                textField="usuarioOcupacao"
                                                v-model="agendamento.laboratorioUsuarioId"
                                                valueField="id"
                                                show-default-option
                                                class="pt-0 mb-0"
                                                @change="handleLaboratorioOcupacao(agendamento)"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>

                <rkm-collapse
                    class="rkm-collapse"
                    visible
                >

                    <rkm-row class="pr-2 pl-2">
                        <rkm-col cols="12">

                            <rkm-area
                                title="Atribuir status para os exames"
                                no-margin-top
                            >

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">

                                        <rkm-form-select
                                            :label="false"
                                            name="Status"
                                            :options="data.form.status"
                                            textField="descricao"
                                            v-model="agendamento.statusId"
                                            valueField="id"
                                            show-default-option
                                            class="pt-0 mb-0"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="auto">

                                        <rkm-button
                                            color="primary"
                                            small
                                            @click="handleAtribuirAgendamento(agendamento)"
                                            :disabled="!agendamento.statusId"
                                        >
                                            Atribuir
                                        </rkm-button>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="p-2">
                        <rkm-col cols="12">

                            <rkm-table
                                :items="agendamento.exames"
                                :fields="fields"
                                hide-filters
                                sort-by="data"
                                :sort-compare="sortCompare"
                                hide-pagination
                            >

                                <template v-slot:cell(exameGrupoNome)="{ item }">
                                    {{item.exameGrupoNome}} {{ item.pertenceGrupo ? `(${item.nomesExame})` : ''}}
                                </template>

                                <template v-slot:cell(status)="{ item }">
                                    <rkm-form-select
                                        :label="false"
                                        :options="data.form.status"
                                        textField="descricao"
                                        v-model="item.statusId"
                                        valueField="id"
                                        show-default-option
                                        class="pt-0 mb-0"
                                    />
                                </template>

                                <template v-slot:cell(actions)="{ item }">

                                    <rkm-button
                                        @click="$refs.ModalObservacao.open(agendamento, item)"
                                        :color="item.observacao ? 'info' : 'secondary'"
                                        small
                                        v-rkm-popover.hover.left="{
                                            title:'Observação',
                                            html:true,
                                            content: item.observacao ? item.observacao : 'Nenhuma observação informada.',
                                        }"
                                    >
                                        <i class="fas fa-comment-alt"></i>
                                    </rkm-button>

                                    <rkm-button
                                        small
                                        title="Imprimir etiqueta"
                                        @click="handlePrint(agendamento, item)"
                                    >
                                        <rkm-icon icon="print" />
                                    </rkm-button>

                                    <rkm-button
                                        color="primary"
                                        small
                                        title="Detalhamento"
                                        @click="$refs.Modal.open(agendamento, item)"
                                    >
                                        <rkm-icon icon="search" />
                                    </rkm-button>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-collapse>
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalObservacao
            :data="data"
            :itemsNotSave="itemsNotSave"
            ref="ModalObservacao"
        />

        <ModalAgendamento
            :data="data"
            ref="ModalAgendamento"
        />

        <ModalReagendar
            v-if="itemsNotRealizados && itemsNotRealizados.length > 0"
            :data="data"
            :itemsNotRealizados="itemsNotRealizados"
            ref="ModalReagendar"
        />

        <ModalPacienteCadastroSimplificado
            @save="reloadPaciente($event)"
            ref="ModalPacienteCadastroSimplificado"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, permissao, data, stringCase, printExameLaboratorial } from '@/mixins'

// Components.
import Modal from './Modal'
import ModalObservacao from './components/observacao/Modal'
import ModalAgendamento from './components/agendamento/Modal'
import ModalReagendar from './components/reagendar/Modal'
import ModalPacienteCadastroSimplificado from '@/components/cadastro/paciente/components/cadastro-simplificado/Modal'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import racaCor from '@/enums/cadastro/cidadao/racaCor'

export default {
    components: { Modal,ModalObservacao, ModalAgendamento, ModalPacienteCadastroSimplificado, ModalReagendar },
    computed: {
        autocompletesRequestParams() {

            return {
                exame: {
                    queryString: {
                        tipo_id: this.tipoExameId,
                        exame_grupo: true,
                    }
                }
            }
        },
        fieldsAutoComplete() {

            return {
                autocompletes: {
                    exame: [
                        { key: 'codigo', searchable: true },
                        { key: 'nome', searchable: true }
                    ],
                }
            }
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                coletaUnidade: { required: true },
                coletaInfraestrutura: { required: true },
            }
        },
        infraestruturas() {

            this.setInfraestrutura()

            if (this.model.unidadeId && this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId)) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.handleInfraestrutura(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        usuario() {

            let usuario = []

            this.data.form.unidadesFaturamento.forEach(item => {

                if (item.infraestruturaId == this.model.coletaInfraestruturaId) {

                    item.profissionais.forEach(profissional => {

                        usuario.push(profissional.usuario)
                    })
                }

                item.faturamentoRelacionado.forEach(relacionado => {

                    if (relacionado.relacionadaInfraestruturaId == this.model.coletaInfraestruturaId) {

                        item.profissionais.forEach(profissional => {

                            usuario.push(profissional.usuario)
                        })
                    }
                })
            })

            if (usuario.length == 1) {

                this.handleUsuario(usuario)
            } else if (usuario.length > 1) {

                this.handleUsuarioLogado(usuario)
            }

            return usuario
        },
        coletaInfraestruturas() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId && this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId)) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.handleColetaInfraestrutura(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        fields() {
            const fields = [
                {
                    key: "exameGrupoNome",
                    label: "Exame / Grupo",
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ]

            return fields
        },
    },
    created() {

        this.repositories = {
            lancamento: this.getConectaSusRepository('exameLaboratorial.lancamentoColeta'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                exame: null,
                exameId: null,
                exameNome: null,
                pacienteId: null,
                unidadeId: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                statusId: null,
                prontuario: null,
                agendamentoNumero: null,
                status: null,
                agendado: 0,
                realizado: 0,
                duplicidade: 0,
                outros: 0,
                faltou: 0,
                pertenceGrupo: null,
                mapaAgrupado: null,
                unidadeNome: null,
                infraestruturaNome: null,
                coletaUnidadeNome: null,
                coletaInfraestruturaNome: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            filtroVisible: true,
            itemsNotSave: [],
            saveAgendamento: {
                agendamentos: [],
            },
            paciente: null,
            usuarioId: null,
            statusId: null,
            unidadeSolicitante: [],
            unidadeColeta: [],
            status: [],
            agendamentoExame: [],
            items: [],
            localPaciente: {
                autocompleteFieldsPaciente: {
                    paciente: [
                        { key: 'cidadao.nome', searchable: true },
                    ],
                },
            },
            enums: {
                statusAgendamento,
                preferenciaNome,
                racaCor
            },
            unwatchers: {
                modelPeriodoEnd: null,
                modelPeriodoStart: null,
            },
            isSearch: false,
            modalPacienteId: null,
            reagendar: null,
            itemsNotRealizados: []
        }
    },
    mixins: [repository, error, object, formats, permissao, data, printExameLaboratorial, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.agendado = this.data.form.agendado
            this.model.duplicidade = this.data.form.duplicidade
            this.model.faltou = this.data.form.faltou
            this.model.outros = this.data.form.outros
            this.model.realizado = this.data.form.realizado

            this.model.periodo = this.data.form.periodo

            this.$nextTick()
                .then(() => this.loadFields())
                .then(() => this.addWatchers())
        },
        save(){

            if (!this.itemsNotSave || this.itemsNotSave && this.itemsNotSave.length == 0) {

                this.showAlert("É necessário realizar uma busca para modificar o agendamento.", "Atenção");

                return false
            }

            if (!this.checkAgendamento()) {

                this.showAlert('É obrigatório selecionar o profissional de coleta para cada exame realizado.', 'Atenção')

                return false
            }

            if (!this.checkLaboratorio()) {

                this.showAlert('É obrigatório selecionar o profissional do laboratório para cada exame realizado.', 'Atenção')

                return false
            }

            const msg = this.validateProntuario()

            if (msg) {

                this.showAlert(msg, 'Atenção')

                return false
            }

            if (this.verificarPermissao('store-exame-laboratorial-agendamento-exame') && this.data.form.exibirReagendarExame) {

                this.itemsNotRealizados = this.clone(this.itemsNotSave);

                this.itemsNotRealizados = this.itemsNotRealizados
                    .filter(agendamento => agendamento.exames.some(
                        exame => exame.statusId !== this.enums.statusAgendamento.AGENDADO &&
                            exame.statusId !== this.enums.statusAgendamento.REALIZADO
                    ))
                    .map(agendamento => ({
                        ...agendamento,
                        exames: agendamento.exames.filter(
                            exame => exame.statusId !== this.enums.statusAgendamento.AGENDADO &&
                                exame.statusId !== this.enums.statusAgendamento.REALIZADO
                        )
                    }));
            }

            this.setLoading();

            this.repositories.lancamento.store(this.prepareData())
                .then(() => {

                    this.showSaveNotification()
                    this.$nextTick(() => this.resetForm())

                    if (this.verificarPermissao('store-exame-laboratorial-agendamento-exame') && this.data.form.exibirReagendarExame) {

                        if (this.itemsNotRealizados && this.itemsNotRealizados.length > 0) {

                            this.$nextTick(() => this.openModalReagendar());
                        }
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        openModalReagendar() {

            this.showConfirmation(
                'Deseja reagendar os exames não coletados?',
                async () => this.$refs.ModalReagendar.open()
            )
        },
        prepareData() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.saveAgendamento.agendamentos = this.clone(this.itemsNotSave)

                const notSave = this.saveAgendamento

                return this.camelObjectKeysToSnakeRecursive(notSave)
            } else {

                const model = this.clone(this.data.model)

                return this.camelObjectKeysToSnakeRecursive(model)
            }
        },
        checkAgendamento() {

            let hasStatus = true

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.itemsNotSave.forEach(item => {

                    item.exames.forEach(exame => {

                    if (exame.statusId == this.enums.statusAgendamento.REALIZADO &&
                        !item.usuarioId) {

                            hasStatus = false
                        }
                    })
                })
            }

            return hasStatus
        },
        checkLaboratorio() {

            let hasStatus = true

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.itemsNotSave.forEach(item => {

                    item.exames.forEach(exame => {

                    if (exame.statusId == this.enums.statusAgendamento.REALIZADO &&
                        !item.laboratorioUsuarioId) {

                            hasStatus = false
                        }
                    })
                })
            }

            return hasStatus
        },
        validateProntuario() {

            if (!this.itemsNotSave || this.itemsNotSave.length === 0) {
                return '';
            }

            const protocolosIncorretos = this.itemsNotSave
                .filter(item => item.controlaProtocoloFechamento && item.regulacaoSolicitacaoId)
                .filter(agendamento => agendamento.regulacaoSolicitacaoNumero !== agendamento.protocoloFechamento)
                .filter(agendamento => agendamento.exames.some(exame => exame.statusId !== this.enums.statusAgendamento.AGENDADO))
                .map(agendamento => agendamento.agendamentoNumero);

            if (protocolosIncorretos.length > 0) {
                return `Os seguintes agendamentos possuem protocolos de fechamento incorretos ou ausentes: <strong>${protocolosIncorretos.join(', ')}</strong>.`;
            }

            return '';
        },
        search() {

            this.setLoading()

            this.repositories.lancamento.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.agendamentos

                    this.model.agendado = data.form.agendado
                    this.model.duplicidade = data.form.duplicidade
                    this.model.faltou = data.form.faltou
                    this.model.outros = data.form.outros
                    this.model.realizado = data.form.realizado

                    this.handleLaboratorioUsuario()

                    this.$nextTick().then(() => this.isSearch = true)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            if (this.paciente) {

                params.pacienteId = this.paciente.id
                params.pacienteNome = this.paciente.cidadao.nome
            }

            if (this.model.exameId) {

                params.pertenceGrupo = this.agendamentoExame.find(u => u.id == this.model.exameId).pertenceGrupo
                params.mapaAgrupado = this.agendamentoExame.find(u => u.id == this.model.exameId).mapaAgrupado
                params.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

                if (this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId)) {

                    this.model.unidadeNome = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).nomeFantasia
                }
            }

            if (this.model.infraestruturaId) {

                if (this.infraestruturas.find(u => u.id == this.model.infraestruturaId)) {

                    this.model.infraestruturaNome = this.infraestruturas.find(u => u.id == this.model.infraestruturaId).nome
                }
            }

            if (this.model.coletaUnidadeId && this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId)) {

                this.model.coletaUnidadeNome = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).nomeFantasia
            }

            if (this.model.coletaInfraestruturaId) {

                if (this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId)) {

                    this.model.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == this.model.coletaInfraestruturaId).nome
                }
            }

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exame = null
            this.model.exameId = null
            this.paciente = null
            this.model.agendamentoNumero = null
            this.model.prontuario = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.statusId = null
            this.itemsNotSave = []
            this.model.agendado = this.data.form.agendado
            this.model.duplicidade = this.data.form.duplicidade
            this.model.faltou = this.data.form.faltou
            this.model.outros = this.data.form.outros
            this.model.realizado = this.data.form.realizado
            this.isSearch = false

            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        setInfraestrutura() {

            if (!this.data.form.isSupervisor && this.data.form.infraestruturaId && this.model.unidadeId) {

                this.model.infraestruturaId = this.data.form.infraestruturaId
            } else {

                this.model.infraestruturaId = null
            }
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        handleAtribuir() {

            let msg = 'Todos os agendamentos serão atribuídos'

            const usuario = this.usuario.find(usuario => usuario.id == this.usuarioId)

            if (usuario) {
                msg = msg.concat(` ao usuário <strong>${usuario.usuarioOcupacao}</strong>`)
            }

            const status = this.data.form.status.find(status => status.id == this.statusId)

            if (status) {
                msg = msg.concat(` ${usuario ? 'e receberão' : 'com'} o status <strong>${status.descricao}</strong>`)
            }

            msg = msg.concat('. Deseja continuar?')

            this.showConfirmation(
                msg,
                async () => this.itemsNotSave.forEach(item => {

                    if (this.usuarioId) {

                        const ocupacao = this.usuario.find(u => u.id == this.usuarioId)

                        item.usuarioId = this.usuarioId
                        item.ocupacaoId = ocupacao.ocupacaoId
                    }

                    item.exames
                        .forEach(exame => {

                            exame.statusId = this.statusId
                        })

                })
            )
        },
        handleAtribuirAgendamento(agendamento) {

            let msg = 'Todos os exames deste agendamento serão atribuídos'

            const usuario = this.usuario.find(usuario => usuario.id == agendamento.usuarioId)

            if (usuario) {
                msg = msg.concat(` ao usuário <strong>${usuario.usuarioOcupacao}</strong>`)
            }

            const status = this.data.form.status.find(status => status.id == agendamento.statusId)

            if (status) {
                msg = msg.concat(` ${usuario ? 'e receberão' : 'com'} o status <strong>${status.descricao}</strong>`)
            }

            msg = msg.concat('. Deseja continuar?')

            this.showConfirmation(
                msg, async () => this.itemsNotSave
                    .filter(item => item.agendamentoId == agendamento.agendamentoId)
                    .forEach(item => {
                        item.exames
                            .forEach(exame => {

                                if (agendamento.statusId) {
                                    exame.statusId = agendamento.statusId
                                }

                                if (agendamento.usuarioId) {

                                    const ocupacao = this.usuario.find(u => u.id == agendamento.usuarioId)

                                    exame.usuarioId = agendamento.usuarioId
                                    exame.ocupacaoId = ocupacao.ocupacaoId
                                }

                                if (agendamento.laboratorioUsuarioId) {

                                    let usuarios = []

                                    this.data.form.laboratoriosFaturamento.forEach(laboratorio => {

                                        if (laboratorio.infraestruturaId == item.laboratorioInfraestruturaId) {

                                            laboratorio.profissionais.forEach(profissional => {

                                                usuarios.push(profissional.usuario)
                                            })
                                        }

                                        laboratorio.faturamentoRelacionado.forEach(relacionado => {

                                            if (relacionado.relacionadaInfraestruturaId == item.laboratorioInfraestruturaId) {

                                                laboratorio.profissionais.forEach(profissional => {

                                                    usuarios.push(profissional.usuario)
                                                })
                                            }
                                        })
                                    })

                                    const ocupacao = usuarios.find(u => u.id == agendamento.laboratorioUsuarioId)

                                    if (ocupacao) {

                                        exame.laboratorioUsuarioId = agendamento.laboratorioUsuarioId
                                        exame.laboratorioOcupacaoId = ocupacao.ocupacaoId
                                    }
                                }
                            })
                    })
            )
        },
        handleListPrint() {

            this.setLoading()

            this.repositories.impressao.lancamentoColeta(this.getSearchParams())
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .finally(() => this.unsetLoading())
        },
        handleEtiquetaPrint() {

            if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                this.print().etiquetaColeta(this.itemsNotSave, this.data.form.sistema, this.data.form.unidade)
            } else {

                this.print().etiquetaColeta(this.data.model.agendamentos, this.data.form.sistema, this.data.form.unidade)
            }
        },
        handlePrint(agendamento, item) {

            this.print().etiquetaColetaIndividual(agendamento, item, this.data.form.sistema, this.data.form.unidade)
        },
        loadFields() {

            this.setLoading()

            this.repositories.lancamento.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidadesSolicitante)
                    this.loadUnidadeColeta(data.model.unidadesColeta)
                    this.loadStatus(data.model.status)
                    this.loadExame(data.model.agendamentos)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(unidades) {

            this.unidadeSolicitante = Object.values(unidades).sort((a, b) => {
                if (a.nomeFantasia < b.nomeFantasia) return -1;
                if (a.nomeFantasia > b.nomeFantasia) return 1;
                return 0;
            });

            this.model.unidadeId = null

            if (unidades && unidades.length === 1) {

                this.model.unidadeId = unidades[0].unidadeId
            }
        },
        loadUnidadeColeta(unidades) {

            this.unidadeColeta = Object.values(unidades).sort((a, b) => {
                if (a.nomeFantasia < b.nomeFantasia) return -1;
                if (a.nomeFantasia > b.nomeFantasia) return 1;
                return 0;
            });

            this.model.coletaUnidadeId = null

            const unidadeColeta = unidades.find(u => u.unidadeId == this.data.form.unidadeId);

            if (unidadeColeta) {

                const infraestruturaCcoleta = unidadeColeta.infraestruturas
                    .find(infraestrutura => infraestrutura.id == this.data.form.infraestruturaId)

                    if (infraestruturaCcoleta) {
                        this.model.coletaUnidadeId = this.data.form.unidadeId
                        this.model.coletaInfraestruturaId = this.data.form.infraestruturaId
                    }
            } else {

                if (unidades && unidades.length === 1) {

                    this.model.coletaUnidadeId = unidades[0].unidadeId
                }
            }
        },
        loadStatus(status) {

            this.status = status
            this.model.statusId = null
        },
        loadExame(agendamento) {

            const exameCadastrado = []

           agendamento.map(exame => {

                const exameInserido = exameCadastrado.find(u => u.id
                    === exame.exameGrupoId && u.pertenceGrupo === exame.pertenceGrupo)

                if (!exameInserido) {

                    exameCadastrado.push({

                        id: exame.exameGrupoId,
                        nome: exame.exameGrupoNome,
                        pertenceGrupo: exame.pertenceGrupo,
                        mapaAgrupado: exame.mapaAgrupado,
                    })
                }
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado
        },
        handleOcupacao(item) {

            this.data.form.unidadesFaturamento.forEach(faturamento => {

                faturamento.profissionais.forEach(profissional => {

                    if (profissional.usuario.id == item.usuarioId) {

                        item.ocupacaoId = profissional.usuario.ocupacaoId
                        item.faturamentoColetaInfraestruturaId = profissional.usuario.infraestruturaId
                    }
                })
            })
        },
        handleLaboratorioOcupacao(item) {

            this.data.form.laboratoriosFaturamento.forEach(faturamento => {

                faturamento.profissionais.forEach(profissional => {

                    if (profissional.usuario.id == item.laboratorioUsuarioId) {

                        item.laboratorioOcupacaoId = profissional.usuario.ocupacaoId
                        item.faturamentoLaboratorioInfraestruturaId = profissional.usuario.infraestruturaId
                    }
                })
            })
        },
        handleUsuario(usuarios) {

            usuarios.map(usuario => {

                if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                    this.itemsNotSave.forEach(agendamento => {

                        agendamento.usuarioId = usuario.id
                        agendamento.ocupacaoId = usuario.ocupacaoId
                    })
                }
            })
        },
        handleUsuarioLogado(usuarios) {

            usuarios
                .filter(usuario => usuario.id == this.data.form.usuarioId)
                .map(usuario => {

                    if (this.itemsNotSave && this.itemsNotSave.length > 0) {

                        this.itemsNotSave.forEach(agendamento => {

                            if (agendamento.laboratorioUsuarioId) {

                                if (!agendamento.usuarios.find(usuario => usuario.id == agendamento.laboratorioUsuarioId)) {

                                    agendamento.usuarioId = usuario.id
                                    agendamento.ocupacaoId = usuario.ocupacaoId
                                }
                            } else {

                                agendamento.usuarioId = usuario.id
                                agendamento.ocupacaoId = usuario.ocupacaoId
                            }
                        })
                    }
                })
        },
        setListagem() {

            this.itemsNotSave = null
            this.isSearch = false
        },
        addWatchers() {

            this.addModelPeridoStartWatcher()
            this.addModelPeridoEndWatcher()
        },
        addModelPeridoStartWatcher() {

            this.unwatchers.modelPeriodoStart = this.$watch('model.periodo.start', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.model.exameId = null

                    this.loadFields()
                }

            })
        },
        addModelPeridoEndWatcher() {

            this.unwatchers.modelPeriodoEnd = this.$watch('model.periodo.end', function () {

                this.setListagem()

                if (this.model.periodo.start && this.model.periodo.end) {

                    this.model.exameId = null

                    this.loadFields()
                }

            })
        },
        reloadPaciente(paciente) {

            const racaCorMap = {
                [this.enums.racaCor.BRANCA]: 'BRANCA',
                [this.enums.racaCor.NEGRA]: 'PRETA',
                [this.enums.racaCor.AMARELA]: 'PARDA',
                [this.enums.racaCor.PARDA]: 'AMARELA',
                [this.enums.racaCor.INDIGENA]: 'INDIGINA',
                [this.enums.racaCor.SEM_INFORMACAO]: 'SEM INFORMAÇÃO'
            };

            this.itemsNotSave.filter(agendamento => agendamento.pacienteId === paciente.id)
                .forEach(agendamento => {

                    agendamento.pacienteNascimento = moment(paciente.cidadao.dataNascimento).format('DD/MM/YYYY');
                    agendamento.pacienteNome = paciente.cidadao.nome;
                    agendamento.pacienteNomeSocial = paciente.cidadao.nomeSocial;
                    agendamento.pacienteProntuario = paciente.prontuario;
                    agendamento.pacienteIdade = paciente.cidadao.idade
                        ?  `${paciente.cidadao.idade.anos} anos`
                        : 'Sem informação';
                    agendamento.cidadaoRacaCor = racaCorMap[paciente.cidadao.racaCorId];
                });

        },
        openModalAgendamento() {

            this.$refs.ModalAgendamento.open()
        },
        handleLaboratorioUsuario() {

            this.itemsNotSave.forEach(agendamento => {

                this.data.form.laboratoriosFaturamento.forEach(laboratorio => {

                    if (laboratorio.infraestruturaId == agendamento.laboratorioInfraestruturaId) {

                        laboratorio.profissionais.forEach(profissional => {

                            agendamento.usuarios.push(profissional.usuario)
                        })
                    }

                    laboratorio.faturamentoRelacionado.forEach(relacionado => {

                        if (relacionado.relacionadaInfraestruturaId == agendamento.laboratorioInfraestruturaId) {

                            laboratorio.profissionais.forEach(profissional => {

                                agendamento.usuarios.push(profissional.usuario)
                            })
                        }
                    })
                })

                if (agendamento.usuarios.length == 1) {

                    agendamento.laboratorioUsuarioId = agendamento.usuarios[0].id
                    agendamento.laboratorioOcupacaoId = agendamento.usuarios[0].ocupacaoId
                    agendamento.faturamentoLaboratorioInfraestruturaId =  agendamento.usuarios[0].infraestruturaId
                    agendamento.faturamentoColetaInfraestruturaId =  agendamento.usuarios[0].infraestruturaId

                } else if (agendamento.usuarios.length > 1) {

                    let usuarioLogado = agendamento.usuarios.find(usuario => usuario.id == this.data.form.usuarioId);

                    if (usuarioLogado) {

                        if (agendamento.laboratorioUsuarioId) {

                            if (!agendamento.usuarios.find(usuario => usuario.id == agendamento.laboratorioUsuarioId)) {

                                agendamento.laboratorioUsuarioId = usuarioLogado.id
                                agendamento.laboratorioOcupacaoId = usuarioLogado.ocupacaoId
                                agendamento.faturamentoLaboratorioInfraestruturaId = usuarioLogado.infraestruturaId
                                agendamento.faturamentoColetaInfraestruturaId = usuarioLogado.infraestruturaId
                            } else {

                                const faturamentoLaboratorio = agendamento.usuarios.find(usuario => usuario.id == agendamento.laboratorioUsuarioId)

                                agendamento.faturamentoLaboratorioInfraestruturaId = faturamentoLaboratorio.infraestruturaId
                            }
                        } else {

                            agendamento.laboratorioUsuarioId = usuarioLogado.id
                            agendamento.laboratorioOcupacaoId = usuarioLogado.ocupacaoId
                            agendamento.faturamentoLaboratorioInfraestruturaId = usuarioLogado.infraestruturaId
                            agendamento.faturamentoColetaInfraestruturaId = usuarioLogado.infraestruturaId
                        }
                    }
                }
            })
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.75rem 1.25rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>